// extracted by mini-css-extract-plugin
export var searchHeader = "_3x-0";
export var searchHeaderDark = "_3x-1";